var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100ZM77.7939 37.5014C79.1753 35.9583 79.0444 33.5876 77.5014 32.2061C75.9583 30.8247 73.5876 30.9556 72.2061 32.4986L55.3603 51.3145C51.9468 55.1272 49.648 57.6814 47.6826 59.3333C45.8103 60.907 44.7106 61.25 43.75 61.25C42.7894 61.25 41.6897 60.907 39.8174 59.3333C37.852 57.6814 35.5532 55.1272 32.1397 51.3145L27.7939 46.4605C26.4124 44.9174 24.0417 44.7865 22.4986 46.1679C20.9556 47.5494 20.8247 49.9202 22.2061 51.4632L26.7376 56.5246C29.9169 60.0759 32.5687 63.0381 34.9918 65.0746C37.5549 67.229 40.3196 68.75 43.75 68.75C47.1804 68.75 49.945 67.229 52.5082 65.0747C54.9313 63.0381 57.5831 60.076 60.7623 56.5247L77.7939 37.5014Z",
    fill: "#00B865"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/Tick Circle.9b39627afae07dd5866b1366d15bb459.svg";
export { ForwardRef as ReactComponent };